"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerformerItemOverlay = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var RaisedButton_1 = __importDefault(require("@atg/icf-react-components/components/RaisedButton"));
var SvgIcon_1 = __importDefault(require("@atg/icf-react-components/components/SvgIcon/SvgIcon"));
var NestedThemeProvider_1 = __importDefault(require("@atg/icf-react-components/ThemeProvider/NestedThemeProvider"));
var Theme_1 = require("@atg/icf-react-components/themes/Theme");
var react_jss_1 = require("react-jss");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var PerformerItemInfoBar_1 = require("./PerformerItemInfoBar");
var PerformerItemLabels_1 = require("./PerformerItemLabels");
var getStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    cover: {
        alignItems: "center",
        boxSizing: "border-box",
        color: theme.colors.textOnDark,
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "center",
        // eslint-disable-next-line @atg/css-rtl-support
        left: 0,
        padding: theme.spacing.base,
        position: "absolute",
        textAlign: "center",
        top: 0,
        width: "100%",
    },
    offlineCover: {
        background: "rgba(33, 33, 33, 0.5)",
        color: theme.colors.textOnDark,
        textTransform: "uppercase",
    },
    unavailableCover: {
        background: "rgba(0, 0, 0, 0.6)",
        paddingBottom: "25px",
    },
    messagePrimary: {
        fontSize: "16px",
    },
    ctaButton: {
        margin: theme.spacing.base,
        fontSize: "14px",
    },
    liveBugContainer: {
        position: "absolute",
        top: "5px",
        insetInlineStart: "5px",
    },
    /* eslint-disable @atg/css-rtl-support */
    mobileIconContainer: {
        position: "absolute",
        bottom: "36px",
        right: "4px",
        zIndex: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    /* eslint-enable  @atg/css-rtl-support */
}); });
var useTranslateAndClasses = function () {
    var _a = __read((0, Ioc_1.useContexts)(Contexts_1.ITranslationServiceContext), 1), translate = _a[0].translate;
    var theme = (0, react_jss_1.useTheme)();
    var classes = getStyles({ theme: theme });
    return { translate: translate, classes: classes };
};
var OfflineOverlay = function () {
    var _a = useTranslateAndClasses(), translate = _a.translate, classes = _a.classes;
    return ((0, jsx_runtime_1.jsx)("div", { className: "".concat(classes.cover, " ").concat(classes.offlineCover), "data-ta-locator": "search.offline", children: translate("search.offline") }));
};
var OnBreakOverlay = function (_a) {
    var onNotifyClicked = _a.onNotifyClicked;
    var _b = useTranslateAndClasses(), translate = _b.translate, classes = _b.classes;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "".concat(classes.cover, " ").concat(classes.unavailableCover), "data-ta-locator": "search.onbreak", children: [(0, jsx_runtime_1.jsx)("div", { className: classes.messagePrimary, children: translate("search.on_break") }), (0, jsx_runtime_1.jsx)(RaisedButton_1.default, { "data-ta-locator": "search.notifyButton", size: "small", className: classes.ctaButton, label: translate("search.notify_when_back"), onClick: onNotifyClicked })] }));
};
var ExclusiveShowOverlay = function (_a) {
    var onNotifyClicked = _a.onNotifyClicked;
    var _b = useTranslateAndClasses(), translate = _b.translate, classes = _b.classes;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "".concat(classes.cover, " ").concat(classes.unavailableCover), "data-ta-locator": "search.exclusive", children: [(0, jsx_runtime_1.jsx)("div", { className: classes.messagePrimary, children: translate("search.exclusive") }), (0, jsx_runtime_1.jsx)(RaisedButton_1.default, { "data-ta-locator": "search.notifyButton", className: classes.ctaButton, size: "small", label: translate("search.notify_when_back"), onClick: onNotifyClicked })] }));
};
var PrivateChatOverlay = function () {
    var _a = useTranslateAndClasses(), translate = _a.translate, classes = _a.classes;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "".concat(classes.cover, " ").concat(classes.unavailableCover), "data-ta-locator": "search.private", children: [(0, jsx_runtime_1.jsx)("div", { className: classes.messagePrimary, children: translate("search.performing_live") }), (0, jsx_runtime_1.jsx)(RaisedButton_1.default, { className: classes.ctaButton, size: "small", label: translate("search.join_show") })] }));
};
var GoldShowOverlay = function () {
    var _a = useTranslateAndClasses(), translate = _a.translate, classes = _a.classes;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "".concat(classes.cover, " ").concat(classes.unavailableCover), "data-ta-locator": "search.goldshow", children: [(0, jsx_runtime_1.jsx)("div", { className: classes.messagePrimary, children: translate("search.performing_live") }), (0, jsx_runtime_1.jsx)(RaisedButton_1.default, { className: classes.ctaButton, size: "small", label: translate("search.join_show"), gold: true })] }));
};
var OverlayContent = function (_a) {
    var isHovering = _a.isHovering, online = _a.online, onBreak = _a.onBreak, exclusiveShow = _a.exclusiveShow, privateChat = _a.privateChat, goldShow = _a.goldShow, preGoldShow = _a.preGoldShow, onNotifyClicked = _a.onNotifyClicked;
    if (!online) {
        return (0, jsx_runtime_1.jsx)(OfflineOverlay, {});
    }
    if (!isHovering) {
        return null;
    }
    if (onBreak) {
        return (0, jsx_runtime_1.jsx)(OnBreakOverlay, { onNotifyClicked: onNotifyClicked });
    }
    if (exclusiveShow) {
        return (0, jsx_runtime_1.jsx)(ExclusiveShowOverlay, { onNotifyClicked: onNotifyClicked });
    }
    if (privateChat) {
        return (0, jsx_runtime_1.jsx)(PrivateChatOverlay, {});
    }
    if (goldShow && !preGoldShow) {
        return (0, jsx_runtime_1.jsx)(GoldShowOverlay, {});
    }
    return null;
};
var mobileCategories = ["mobile", "tsmobile", "mobileguy"];
var PerformerItemOverlay = function (_a) {
    var _b, _c;
    var performerData = _a.performerData, isHovering = _a.isHovering, previewLoading = _a.previewLoading, onFavoriteIconClicked = _a.onFavoriteIconClicked, onNotifyClicked = _a.onNotifyClicked, showHeadline = _a.showHeadline;
    var _d = performerData.liveState, specialShow = _d.specialShow, goldShow = _d.goldShow, preGoldShow = _d.preGoldShow, onBreak = _d.onBreak, exclusiveShow = _d.exclusiveShow, privateChat = _d.privateChat;
    var online = performerData.online;
    var classes = getStyles({ theme: (0, react_jss_1.useTheme)() });
    var showType = specialShow ? "specialShow" : goldShow || preGoldShow ? "goldShow" : undefined;
    var streamingOnMobile = (_c = (_b = performerData.categoryName) === null || _b === void 0 ? void 0 : _b.some(function (category) { return mobileCategories.includes(category.toLowerCase()); })) !== null && _c !== void 0 ? _c : false;
    return ((0, jsx_runtime_1.jsx)(NestedThemeProvider_1.default, { themeMode: Theme_1.ThemeMode.dark, children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(OverlayContent, { isHovering: isHovering, online: online, onBreak: onBreak, exclusiveShow: exclusiveShow, privateChat: !!privateChat, goldShow: goldShow, preGoldShow: preGoldShow, onNotifyClicked: onNotifyClicked }), (0, jsx_runtime_1.jsx)(PerformerItemInfoBar_1.PerformerItemInfoBar, { age: performerData.age, country: performerData.country, isFavorite: performerData.favorite, isHovering: isHovering, isOnline: online, nickname: performerData.nickname, previewLoading: previewLoading, stars: performerData.stars, onFavoriteIconClicked: onFavoriteIconClicked, headline: (showHeadline && performerData.headlineMessage) || "", performerData: performerData }), (0, jsx_runtime_1.jsx)(PerformerItemLabels_1.PerformerItemLabels, { isNew: performerData.new, showType: showType, hasVibe: performerData.toyEnabled, hasVoip: performerData.voipAvailable }), streamingOnMobile && ((0, jsx_runtime_1.jsx)("div", { className: classes.mobileIconContainer, "data-ta-locator": "PerformerItemOverlay-mobileIcon", children: (0, jsx_runtime_1.jsx)(SvgIcon_1.default, { name: "smartphone", size: "small", fill: "#fff", dropShadow: true }) }))] }) }));
};
exports.PerformerItemOverlay = PerformerItemOverlay;
exports.PerformerItemOverlay.displayName = "PerformerItemOverlay";
//# sourceMappingURL=PerformerItemOverlay.js.map